import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import Input from '../../../components/Form/Input';
import { OutTransactionFormData } from './outTransactionTypes';

interface OutSafeDetailsSectionProps {
  register: UseFormRegister<OutTransactionFormData>;
  errors: FieldErrors<OutTransactionFormData>;
  selectedSafeId: string;
  getSelectedSafeName: () => string;
}

const OutSafeDetailsSection: React.FC<OutSafeDetailsSectionProps> = ({
  register,
  errors,
  selectedSafeId,
  getSelectedSafeName,
}) => {
  return (
    <div className="bg-gray-50 rounded-xl p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
        <svg className="w-5 h-5 mr-2 text-ocean-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
        Safe Box Transaction Details
      </h3>

      <div className="space-y-6">
        <div className="bg-blue-50 p-4 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>Selected Safe Box:</strong> {getSelectedSafeName()}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Input
            label="Transaction Amount"
            type="number"
            step="0.01"
            {...register('amount', {
              required: 'Amount is required',
              valueAsNumber: true,
              min: { value: 0.01, message: 'Amount must be positive' }
            })}
            error={errors.amount?.message}
            placeholder="0.00"
          />
          <div></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Input
            label="Transaction Date"
            type="date"
            {...register('transactionDate', { required: selectedSafeId ? 'Transaction date is required' : false })}
            error={errors.transactionDate?.message}
          />
          <div></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Input
            label="Recipient Name"
            {...register('recipientName', { required: selectedSafeId ? 'Recipient name is required' : false })}
            error={errors.recipientName?.message}
            placeholder="Enter recipient name"
          />
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default OutSafeDetailsSection;
